import React from "react";
import PropTypes from "prop-types";
import { observer } from "mobx-react";
import { MrbToggle } from "mrb/components/checkbox";

const CertifierContentItemTemplate = observer(function CertifierContentItemTemplate({ item, onToggle }) {
    return (
        <MrbToggle
            id={`certifier-toggle-${item.contentId}`}
            value={item.isApproved || false}
            onChange={(event) => {
                event.preventDefault();
                event.stopPropagation();
                onToggle(item, !item.isApproved);
            }}
        />
    );
});

CertifierContentItemTemplate.propTypes = {
    item: PropTypes.object.isRequired,
    onToggle: PropTypes.func.isRequired,
};

export default CertifierContentItemTemplate;
